import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Input } from "../../../components/form/Input/Input";
import { sendMessage } from "../redux/AISagas";
import Button from "../../../components/form/button/button";

const MessageComposer = ({ inputMessage, setInputMessage, pageName, filter }) => {
  const dispatch = useDispatch();
  const questions = useSelector((state) => state.ai.currentSession.questions);
  const loading = useSelector((state) => state.ai.isLoading);

  const handleUpdate = () => {
    dispatch(sendMessage({ message: inputMessage, pageName, filter }));
    setInputMessage("");
  };

  return (
    <div className="message-composer">
      <div className="message-composer__input-area">
        <Input
          disabled={loading}
          placeholder="Write your message here..."
          maxLength={1000}
          value={inputMessage}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              if (inputMessage.trim() && !loading) handleUpdate();
            }
          }}
          onChange={setInputMessage}
        />
        <Button
          text="Chat"
          disabled={loading || inputMessage.trim() === ""}
          onClick={handleUpdate}
        />
      </div>

      <div className="message-composer__suggestions">
        {questions.map((elem, idx) => (
          <div
            key={idx}
            className={`message-composer__suggestion-item  ${loading ? "disabled" : ""}`}
            onClick={() => {
              if (!loading) {
                dispatch(sendMessage({ message: elem, pageName, filter }));
              }
            }}
          >
            {elem}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MessageComposer;
